/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import { format, isValid, parseISO } from "date-fns";

const ISO_DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function toDate(value?: string | Date | null): Date | undefined {
  if (!value) return undefined;
  if (value instanceof Date) {
    return isValid(value) ? value : undefined;
  }

  const parsed = ISO_DATE_ONLY.test(value)
    ? new Date(`${value}T00:00:00`)
    : parseISO(value);

  return isValid(parsed) ? parsed : undefined;
}

export function toIsoDateString(value?: string | Date | null): string {
  const date = toDate(value);
  return date ? format(date, "yyyy-MM-dd") : "";
}

export function formatDateDisplay(
  value?: string | Date | null,
  displayFormat: string = "PPP",
): string {
  const date = toDate(value);
  return date ? format(date, displayFormat) : "";
}
